import {Button, Dialog, DialogContent, Typography} from '@mui/material';

export interface StudySessionModuleErrorProps {
  open: boolean;
  onClose: () => void;
}

export default function StudySessionModuleError({open, onClose}: StudySessionModuleErrorProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent sx={{py: 2}}>
        <Typography color="error" sx={{mb: 2}}>
          Failed to load available subjects. Please try again.
        </Typography>
        <Button onClick={onClose}>Close</Button>
      </DialogContent>
    </Dialog>
  );
}
